module.exports = __webpack_public_path__ + "static/favicon-faa0b66b6563845df45f6779b9fe5ef3.ico";